import React, { useEffect } from "react";
import { Card, Button, Form } from "react-bootstrap";
import moment from "moment";
import "./ProjectRemarksTab.css";

const ProjectRemarksTab = ({
  // Data
  remarks,
  remarksLoading,

  // Edit states
  editingRemarkId,
  editingRemarkText,
  updatingRemark,

  // Input states
  remarkText,
  addingRemark,

  // Permissions
  hasEditPermission,

  // Handlers
  setRemarkText,
  handleAddRemark,
  startEditRemark,
  cancelEditRemark,
  setEditingRemarkText,
  handleUpdateRemark,
}) => {
  // Add useEffect to log when remarks prop changes
  useEffect(() => {
    console.log("=== ProjectRemarksTab received remarks prop ===");
    console.log("remarks array:", remarks);
    console.log("remarks length:", remarks?.length);

    if (remarks && remarks.length > 0) {
      console.log("First remark in props:", remarks[0]);
      console.log("createdBy in first remark:", remarks[0].createdBy);
      console.log("createdByName in first remark:", remarks[0].createdByName);
      console.log("remarkText in first remark:", remarks[0].remarkText);
    }
  }, [remarks]);

  return (
    <div className="prt-remark-container">
      <div className="prt-remark-header">
        <div className="prt-remark-header-left">
          <div className="prt-remark-header-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div>
            <h3 className="prt-remark-title">Project Remarks</h3>
            <p className="prt-remark-subtitle">
              Add and manage project comments
            </p>
          </div>
        </div>
        <div className="prt-remark-stats">
          <span className="prt-remark-stats-badge">
            {remarks?.length || 0} Remarks
          </span>
        </div>
      </div>

      {/* Add Remark Section */}
      {hasEditPermission() && (
        <div className="prt-remark-input-wrapper">
          <div className="prt-remark-input-container">
            <div className="prt-remark-input-avatar">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="prt-remark-input-field">
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Write a remark..."
                value={remarkText}
                onChange={(e) => setRemarkText(e.target.value)}
                className="prt-remark-textarea"
              />
              <div className="prt-remark-input-actions">
                <Button
                  variant="primary"
                  onClick={handleAddRemark}
                  disabled={addingRemark}
                  className="prt-remark-submit-btn"
                >
                  {addingRemark ? (
                    <>
                      <span className="prt-spinner"></span>
                      Adding...
                    </>
                  ) : (
                    <>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M2 21l21-9L2 3v7l15 2-15 2v7z"
                          fill="currentColor"
                        />
                      </svg>
                      Add Remark
                    </>
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Remarks List */}
      {remarksLoading ? (
        <div className="prt-remark-loading">
          <div className="prt-remark-loading-spinner"></div>
          <p>Loading remarks...</p>
        </div>
      ) : remarks.length === 0 ? (
        <div className="prt-remark-empty">
          <div className="prt-remark-empty-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
              <path
                d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
                fill="currentColor"
                opacity="0.3"
              />
              <path d="M7 9h10v2H7V9zm0 4h7v2H7v-2z" fill="currentColor" />
            </svg>
          </div>
          <h5 className="prt-remark-empty-title">No Remarks Yet</h5>
          <p className="prt-remark-empty-message">
            {hasEditPermission()
              ? "Be the first to add a remark to this project."
              : "No remarks have been added to this project yet."}
          </p>
        </div>
      ) : (
        <div className="prt-remark-timeline">
          {(Array.isArray(remarks) ? remarks : []).map((remark, index) => {
            console.log(`Rendering remark ${index}:`, remark);
            return (
              <div
                key={remark.guid || index}
                className="prt-remark-timeline-item"
              >
                <div className="prt-remark-timeline-marker"></div>

                <div className="prt-remark-card">
                  <div className="prt-remark-card-header">
                    <div className="prt-remark-user-info">
                      <div className="prt-remark-user-avatar">
                        {(
                          (remark.createdByName || remark.createdBy)?.charAt(
                            0,
                          ) || "U"
                        ).toUpperCase()}
                      </div>
                      <div>
                        <div className="prt-remark-user-name">
                          {remark.createdByName || remark.createdBy}
                        </div>
                        <div className="prt-remark-timestamp">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm.5-13H11v6l5.2 3.1.8-1.2-4.5-2.7z"
                              fill="currentColor"
                            />
                          </svg>
                          {remark.createdOn
                            ? moment(remark.createdOn).format(
                                "DD MMM YYYY, hh:mm A",
                              )
                            : moment(
                                remark.createdOnDate?.split("T")[0] +
                                  " " +
                                  remark.createdOnTime,
                              ).format("DD MMM YYYY, hh:mm A")}
                        </div>
                      </div>
                    </div>

                    {hasEditPermission() && editingRemarkId !== remark.guid && (
                      <button
                        onClick={() => startEditRemark(remark)}
                        className="prt-remark-edit-btn"
                        title="Edit remark"
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                            fill="currentColor"
                          />
                        </svg>
                        Edit
                      </button>
                    )}
                  </div>

                  {editingRemarkId === remark.guid ? (
                    <div className="prt-remark-edit-mode">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={editingRemarkText}
                        onChange={(e) => setEditingRemarkText(e.target.value)}
                        className="prt-remark-edit-textarea"
                        autoFocus
                      />
                      <div className="prt-remark-edit-actions">
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() =>
                            handleUpdateRemark(remark.guid, editingRemarkText)
                          }
                          disabled={updatingRemark}
                          className="prt-remark-save-btn"
                        >
                          {updatingRemark ? "Saving..." : "Save Changes"}
                        </Button>
                        <Button
                          variant="secondary"
                          size="sm"
                          onClick={cancelEditRemark}
                          disabled={updatingRemark}
                          className="prt-remark-cancel-btn"
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div className="prt-remark-card-content">
                      <div className="prt-remark-text">
                        {remark.remarkText || remark.remarks}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProjectRemarksTab;

// import React, { useEffect } from "react";
// import { Card, Button, Form } from "react-bootstrap";
// import moment from "moment";

// const ProjectRemarksTab = ({
//   // Data
//   remarks,
//   remarksLoading,

//   // Edit states
//   editingRemarkId,
//   editingRemarkText,
//   updatingRemark,

//   // Input states
//   remarkText,
//   addingRemark,

//   // Permissions
//   hasEditPermission,

//   // Handlers
//   setRemarkText,
//   handleAddRemark,
//   startEditRemark,
//   cancelEditRemark,
//   setEditingRemarkText,
//   handleUpdateRemark,
// }) => {
//   // Add useEffect to log when remarks prop changes
//   useEffect(() => {
//     console.log("=== ProjectRemarksTab received remarks prop ===");
//     console.log("remarks array:", remarks);
//     console.log("remarks length:", remarks?.length);

//     if (remarks && remarks.length > 0) {
//       console.log("First remark in props:", remarks[0]);
//       console.log("createdBy in first remark:", remarks[0].createdBy);
//       console.log("createdByName in first remark:", remarks[0].createdByName);
//       console.log("remarkText in first remark:", remarks[0].remarkText);
//     }
//   }, [remarks]);

//   return (
//     <div className="project-view-fade-in">
//       <Card>
//         <Card.Body>
//           <h5 className="mb-3">Project Remarks</h5>

//           {/* Add Remark - Only for users with edit permission */}
//           {hasEditPermission() && (
//             <div className="d-flex mb-3">
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 placeholder="Add a remark..."
//                 value={remarkText}
//                 onChange={(e) => setRemarkText(e.target.value)}
//               />
//               <Button
//                 variant="primary"
//                 className="ms-2"
//                 onClick={handleAddRemark}
//                 disabled={addingRemark}
//               >
//                 {addingRemark ? "Adding..." : "Add"}
//               </Button>
//             </div>
//           )}

//           {/* Remarks List */}
//           {remarksLoading ? (
//             <p>Loading remarks...</p>
//           ) : remarks.length === 0 ? (
//             <p className="text-muted">No remarks yet.</p>
//           ) : (
//             <div>
//               {(Array.isArray(remarks) ? remarks : []).map((remark, index) => {
//                 console.log(`Rendering remark ${index}:`, remark);
//                 return (
//                   <Card key={remark.guid || index} className="mb-2">
//                     <Card.Body>
//                       <div className="d-flex justify-content-between align-items-start">
//                         <div>
//                           {/* Use createdByName if available, fallback to createdBy */}
//                           <strong>
//                             {console.log(
//                               `Display name for ${index}:`,
//                               remark.createdByName || remark.createdBy,
//                             )}
//                             {remark.createdByName || remark.createdBy}
//                           </strong>
//                           <small className="text-muted ms-2">
//                             {remark.createdOn
//                               ? moment(remark.createdOn).format(
//                                   "DD MMM YYYY HH:mm",
//                                 )
//                               : moment(
//                                   remark.createdOnDate?.split("T")[0] +
//                                     " " +
//                                     remark.createdOnTime,
//                                 ).format("DD MMM YYYY HH:mm")}
//                           </small>
//                         </div>
//                         {/* Edit button - Only show for users with edit permission */}
//                         {hasEditPermission() &&
//                           editingRemarkId !== remark.guid && (
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               onClick={() => startEditRemark(remark)}
//                               title="Edit remark"
//                             >
//                               Edit
//                             </Button>
//                           )}
//                       </div>

//                       {/* Edit Mode */}
//                       {editingRemarkId === remark.guid ? (
//                         <div className="mt-2">
//                           <Form.Control
//                             as="textarea"
//                             rows={3}
//                             value={editingRemarkText}
//                             onChange={(e) =>
//                               setEditingRemarkText(e.target.value)
//                             }
//                             className="mb-2"
//                           />
//                           <div className="d-flex gap-2">
//                             <Button
//                               variant="success"
//                               size="sm"
//                               onClick={() =>
//                                 handleUpdateRemark(
//                                   remark.guid,
//                                   editingRemarkText,
//                                 )
//                               }
//                               disabled={updatingRemark}
//                             >
//                               {updatingRemark ? "Saving..." : "Save"}
//                             </Button>
//                             <Button
//                               variant="secondary"
//                               size="sm"
//                               onClick={cancelEditRemark}
//                               disabled={updatingRemark}
//                             >
//                               Cancel
//                             </Button>
//                           </div>
//                         </div>
//                       ) : (
//                         <div className="mt-2">
//                           {console.log(
//                             `Displaying remark text:`,
//                             remark.remarkText || remark.remarks,
//                           )}
//                           {remark.remarkText || remark.remarks}
//                         </div>
//                       )}
//                     </Card.Body>
//                   </Card>
//                 );
//               })}
//             </div>
//           )}
//         </Card.Body>
//       </Card>
//     </div>
//   );
// };

// export default ProjectRemarksTab;
